import Api from "@/services/Index";

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/logs", config);
};

const getExceptions = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/logs/exceptions", config);
};

const getModels = async (config=null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/logs/models", config);
};

const rollBack = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/logs/"+id+"/rollback");
};
const exportExcel = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/logs/excel-export',{...config, responseType: 'arraybuffer'});
}


export default {
    getAll,
    getModels,
    getExceptions,
    rollBack,
    exportExcel
};
